import { TabPanel } from './TabPanel'
import { EmailFiltersPanel } from './EmailFiltersPanel'
import { FavoriteContact } from './FavoriteContact'
import { EmailsRecipientsTable } from './EmailsRecipientsTable'
import { SelectedRecipients } from './SelectedRecipients'
import { SendEmailForm } from './SendEmailForm'

export const SendEmailTab = ({
  tabValue,
  tabIndex,
  copros,
  coprosLoading,
  coproValue,
  setCoproValue,
  selectAll,
  handleSelectAllChange,
  selectAllCS,
  handleSelectAllCS,
  classes,
  contacts,
  setSelected,
  setSelectAllCS,
  setSelectAll,
  handleChange,
  theme,
  selected,
  recipients,
  editRecipients,
  subject,
  setSubject,
  quillValue,
  handleChangeQuill,
  attachments,
  setAttachments,
  handleSend,
  recipientsType,
  setRecipientsType,
}) => {
  return (
    <>
      <TabPanel value={tabValue} index={tabIndex} classes={classes}>
        <form>
          <EmailFiltersPanel
            copros={copros}
            loading={coprosLoading}
            value={coproValue}
            setValue={setCoproValue}
            selectAll={selectAll}
            handleSelectAllChange={handleSelectAllChange}
            selectAllCS={selectAllCS}
            handleSelectAllCS={handleSelectAllCS}
          />
          {coproValue && contacts?.length > 0 && (
            <>
              <FavoriteContact
                classes={classes}
                contacts={contacts}
                value={coproValue}
                setSelected={setSelected}
                setSelectAll={setSelectAll}
                setSelectAllCS={setSelectAllCS}
              />

              <EmailsRecipientsTable
                contacts={contacts}
                selected={selected}
                classes={classes}
                handleChange={handleChange}
                theme={theme}
              />

              <SelectedRecipients
                selected={selected}
                setSelected={setSelected}
                recipientsType={recipientsType}
              />
            </>
          )}
        </form>
      </TabPanel>

      <SendEmailForm
        value={coproValue}
        attachments={attachments}
        setAttachments={setAttachments}
        handleSend={handleSend}
        handleChangeQuill={handleChangeQuill}
        classes={classes}
        recipients={recipients}
        editRecipients={editRecipients}
        subject={subject}
        setSubject={setSubject}
        quillValue={quillValue}
        selected={selected}
        recipientsType={recipientsType}
        setRecipientsType={setRecipientsType}
      />
    </>
  )
}
